module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DC79_1SD_G9F.de2375f3.png";